export const environment = {
  production: true,
  buildId: '2687725503718371',
  configFile: 'config.json',
};
